import { UserType } from '@app-types/user';

export enum CACHE_TAGS {
    'ALL' = 'cacheAll',
    'PRODUCTS' = 'cacheProducts',
    'CMS' = 'cacheCms',
    'CONFIG' = 'cacheConfig',
    'RBANQUE_JWKS' = 'cacheRBanqueJwks',
}

export type HttpConfig = {
    headers?: Record<string, string>;
    controller?: AbortController;
    tags?: CACHE_TAGS[];
    ttl?: number;
    user?: UserType;
};

export class NetworkError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    output: any;
    status: number;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message: string, output: any, status: number) {
        super(message);
        this.output = output;
        this.name = 'NetworkError';
        this.status = status;
    }
}

export abstract class HttpService {
    public abstract get<T>(
        url: string,
        data?: Record<string, string | number | boolean | null>,
        config?: HttpConfig,
    ): Promise<T>;

    public abstract post<T>(url: string, data?: object, config?: HttpConfig): Promise<T>;

    protected abstract processResponse<T>(response: unknown): Promise<T>;
}
